import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Action from '../../../actions/AdminSettingBooth';
import SettingBoothSelector from '../../../selectors/AdminSettingBooth';
import SettingBoothPage from '../../../pages/Admin/SettingBooth/SettingBoothPage';
import withAuth from '../../../common/WithAuth';
import { GetInfoEventRequested } from '../../../actions/EventManagement';

const mapStateToProps = (state) => {
    const settingBoothData = SettingBoothSelector.createSettingSelector()(state);
    const isLoading = state.adminSettingBooth.get.isFetching
    || state.adminSettingBooth.update.isFetching;

    return {
        settingBoothData,
        eventInfo: state.eventManagement.infoEvent.data,
        errors: state.adminSettingBooth.update.errors,
        isCompleted: state.adminSettingBooth.update.isCompleted,
        isCompletedGet: state.adminSettingBooth.get.isCompleted,
        isSuccessful: state.adminSettingBooth.update.isSuccessful,
        isLoading,
    };
};

const mapDispatchToProps = (dispatch) => ({
    getSettingBooth: (eventShortName) => dispatch(Action.getSettingBoothRequested(eventShortName)),
    updateSettingBooth: (eventShortName, body) => dispatch(Action.updateSettingBoothRequested({ eventShortName, body })),
    getSettingBoothClear: () => dispatch(Action.getSettingBoothClear()),
    updateSettingBoothClear: () => dispatch(Action.updateSettingBoothClear()),
    fetchInfoEvent: (param) => dispatch(GetInfoEventRequested(param)),
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(SettingBoothPage);
